import React from 'react';
type Status = 'active' | 'draft' | 'pending' | 'confirmed' | 'unsubscribed' | 'archived';
interface StatusBadgeProps {
  status: Status | string;
}
export function StatusBadge({
  status
}: StatusBadgeProps) {
  const styles = {
    active: 'bg-green-100 text-green-800',
    draft: 'bg-gray-100 text-gray-800',
    archived: 'bg-gray-100 text-gray-600',
    inactive: 'bg-red-100 text-red-800',
    pending: 'bg-yellow-100 text-yellow-800',
    confirmed: 'bg-green-100 text-green-800',
    unsubscribed: 'bg-red-100 text-red-800',
    accepted: 'bg-green-100 text-green-800',
    rejected: 'bg-red-100 text-red-800',
    scheduled: 'bg-blue-100 text-blue-800',
    sent: 'bg-green-100 text-green-800',
    exported: 'bg-purple-100 text-purple-800'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${styles[status as keyof typeof styles] || 'bg-gray-50 text-gray-600 border-gray-200'}`} data-id="element-375">
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>;
}